import { SET_MASTER_DATA } from '../actions/constants';

const defaultState: any = {};

export default (state: any = defaultState, action) => {
  switch (action.type) {
    case SET_MASTER_DATA: {
      return {
        ...state,
        ...action.data,
      };
    }

    default:
      return state;
  }
};
